// extracted by mini-css-extract-plugin
export var item = "Title-module--item--Wt6UZ";
export var itemBtn = "Title-module--item-btn--phSJb";